import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { Angulartics2OnModule } from 'angulartics2';
import { LazyLoadImageModule } from 'ng-lazyload-image';

import { LeftNavComponent } from './left-nav/left-nav.component';
import { RightNavComponent } from './right-nav/right-nav.component';
import { SideNavComponent } from './side-nav.component';

import { CircleInitialsModule } from '../circle-initials/circle-initials.module';
import { SiteLinksModule } from '../site-links/site-links.module';

import { SharedDirectivesModule } from '../../shared/directives/shared-directives.module';
import { SharedPipesModule } from '../../shared/pipes/shared-pipes.module';

@NgModule({
    imports: [
        Angulartics2OnModule,
        CircleInitialsModule,
        CommonModule,
        LazyLoadImageModule,
        SiteLinksModule,
        SharedDirectivesModule,
        SharedPipesModule,
        TranslateModule.forChild()
    ],
    declarations: [
        SideNavComponent,
        LeftNavComponent,
        RightNavComponent
    ],
    exports: [
        SideNavComponent
    ]
})
export class SideNavModule { }
